// Copyright ©️ 2026 eVolve MEP, LLC

import type { MantineColor } from '@mantine/core';

import type { BaseStateColorMap } from 'components/Mantine/StatusEditor/useCustomStatuses';

/** Used to represent a "Late" `needByDate` */
export const lateColor = 'red.8' as const satisfies MantineColor;

export const workOrderStateColorMap: BaseStateColorMap<'Work Order'> = {
  'Draft': 'cyan.7',
  'Rejected': 'red.9',
  'Submitted': 'violet.8',
  'Pending': 'violet.5',
  'Approved': 'green.8',
  'Canceled': 'gray.5',
  'Not Started': {
    color: 'yellow.7',
    label: 'Not started',
  },
  'In Progress': {
    color: 'indigo.7',
    label: 'In progress',
  },
  'Completed': 'teal.8',
  'Blocked': 'orange.7',
  'Transferred': 'grape.6',
  'Request for Cancel': {
    color: 'red',
    label: 'Cancel request',
  },
};

export const taskStatusColorMap: BaseStateColorMap<'Task'> = {
  'Not Started': {
    color: 'yellow.7',
    label: 'Not started',
  },
  'Started': {
    color: 'indigo.7',
    label: 'In progress',
  },
  'Paused': {
    color: 'indigo.7',
    label: 'In progress',
  },
  'Completed': 'teal.8',
};

export const shipmentStateColorMap: BaseStateColorMap<'Shipment'> = {
  'Draft': 'cyan.7',
  'Ready to Ship': 'yellow.7',
  'Shipped': 'indigo.7',
  'Delivered': 'teal.8',
};
